export const SlModalIds = {
  privacyPolicyModal: 'privacyPolicyModal',
  termsAndConditionModal: 'termsAndConditionModal',
};
